/*
 * @Author: SK-20251129GXNS\Administrator zpx
 * @Date: 2025-12-30 13:48:48
 * @LastEditors: SK-20251129GXNS\Administrator zpx
 * @LastEditTime: 2025-12-30 14:12:18
 * @FilePath: \frontend\src\utils\fornatLocalImg.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

/**
 * 本地/线上图片兼容公用函数
 * IMAGE__WITH__TYPE 是否开启线上 [local-本地] [cdn-线上]
 */
const ImageTypeEnum = {
  CDN: 'cdn',
  LOCAL: 'local',
}
const ImageFlage = ImageTypeEnum.LOCAL
let IMAGE__WITH__TYPE = ''

/**
 * 获取本地图片
 */
let themeIcons = null
let themeIconsList = []
const getImageUrlWithLocal = () => {
  themeIcons = import.meta.glob('@/assets/theme/*/*', { eager: true })
  themeIconsList = Object.keys(themeIcons).map((path) => {
    const splitList = path.split('/')
    const name = splitList.pop().replace('/src/assets/theme', '')
    const url = `/${splitList[4]}/${name}`
    return {
      url,
      component: themeIcons[path].default,
    }
  })
}

/**
 * 获取线上图片
 * @param {string} path - 本地图片路径
 * @returns {string} CDN路径
 */
export function getImageUrlWithCDN(path) {
  const initConfig = JSON.parse(localStorage.getItem('localConfig')) || {}
  const cdnBase = initConfig.cdn_url + '/' // 默认CDN路径 @/assets/
  const skinIcon = initConfig.skin + '/' // AE 0888  CL
  const theme = initConfig.theme + '/' // 主题皮肤
  // 如果 path包含径以 @/assets/ 开头，则不变  // if (path.startsWith('@/assets/')) { return path }
  // 否则，将本地路径转换为CDN路径
  // const result = cdnBase + 'AE_ICON/' + theme + path
  const result = cdnBase + skinIcon + theme + path
  return result
}

/**
 * 获取线上/本地图片
 * @param {*} path - 图片路径
 * @returns
 */
const getIconsObj = (path) => {
  const obj = themeIconsList.find((e) => e.url === path)
  return obj && obj !== undefined ? obj.component : ''
}
export function getImageUrlWithCDN_LOCAL(path, type) {
  let __ImgType__
  if (
    type !== undefined &&
    type !== null &&
    type !== '' &&
    typeof type === 'string' &&
    (type === ImageTypeEnum.LOCAL || type === ImageTypeEnum.CDN)
  ) {
    __ImgType__ = type
  } else {
    __ImgType__ = IMAGE__WITH__TYPE
  }

  switch (__ImgType__) {
    case ImageTypeEnum.CDN:
      // return getImageUrlWithCDN(`theme${path}`)
      return getIconsObj(path)
    case ImageTypeEnum.LOCAL:
      return getIconsObj(path)
  }
}

/**
 * 初始化获取图片类型函数
 */
const initImageData = () => {
  // 强制始终使用本地图片
  IMAGE__WITH__TYPE = ImageTypeEnum.LOCAL

  nextTick(() => {
    getImageUrlWithLocal()
  })
}
initImageData()

/**
 * 处理单个图片路径
 * @param {string} path - 原始图片路径
 * @returns {string} - 处理后的图片路径
 */
export function handleImagePath(path) {
  return getImageUrlWithCDN(path)
}

// /**
//  * 预处理页面中的所有图片路径，将本地路径替换为CDN路径
//  * @param {Object} components - 包含图片路径的对象
//  * @returns {Object} - 处理后的对象，所有图片路径已替换为CDN路径
//  */
// export function processImagePaths(components) {
//   const processed = {}
//   for (const [key, value] of Object.entries(components)) {
//     if (typeof value === 'string' && value.startsWith('@/assets/')) {
//       processed[key] = getImageUrlWithCDN(value)
//     } else if (typeof value === 'object' && value !== null) {
//       processed[key] = processImagePaths(value)
//     } else {
//       processed[key] = value
//     }
//   }
//   return processed
// }
